import { useAppSelector } from '@/hooks/redux-hooks';

const useIsPermissionsLoaded = (): boolean =>
  useAppSelector(state => state.tripToken.status === 'fulfilled');

export default useIsPermissionsLoaded;
